
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/promotions/[[...slug]]",
      function () {
        return require("private-next-pages/products/promotions/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/promotions/[[...slug]]"])
      });
    }
  